import { useEffect, useRef } from 'react';

const themeByPlanet = { suma: 'suma', resta: 'resta', mult: 'multiplicacion', division: 'division' };

const CosmicValueCapsule = ({ capsule, onComplete }) => {
  const continueButtonRef = useRef(null);

  useEffect(() => {
    if (!capsule) return undefined;
    const focusTimer = window.setTimeout(() => continueButtonRef.current?.focus(), 0);
    return () => window.clearTimeout(focusTimer);
  }, [capsule]);

  if (!capsule) return null;

  const theme = themeByPlanet[capsule.planetId] || 'suma';

  return (
    <section
      className={'tmag-cosmic-capsule tmag-cosmic-capsule--' + theme}
      role="dialog"
      aria-modal="true"
      aria-labelledby="cosmic-value-title"
      aria-describedby="cosmic-value-message"
    >
      <div className="tmag-cosmic-capsule__dialog">
        <div className="tmag-cosmic-capsule__halo" aria-hidden="true">
          <span className="tmag-cosmic-capsule__star tmag-cosmic-capsule__star--one">✦</span>
          <span className="tmag-cosmic-capsule__star tmag-cosmic-capsule__star--two">✧</span>
          <span className="tmag-cosmic-capsule__star tmag-cosmic-capsule__star--three">✦</span>
        </div>
        <p className="tmag-cosmic-capsule__eyebrow">CÁPSULA CÓSMICA</p>
        <h2 id="cosmic-value-title">REFLEXIONA</h2>
        <p className="tmag-cosmic-capsule__category">VALOR · {capsule.message.category}</p>
        <p id="cosmic-value-message" className="tmag-cosmic-capsule__message">“{capsule.message.message}”</p>
        <button
          ref={continueButtonRef}
          type="button"
          className="tmag-cosmic-capsule__continue"
          onClick={onComplete}
        >
          CONTINUAR <span aria-hidden="true">→</span>
        </button>
      </div>
    </section>
  );
};

export default CosmicValueCapsule;
